import BaseModelAPI from '../BaseModelAPI';

export default class FinishGoodQcConfirmation extends BaseModelAPI {
	static entity = 'newobject2326';
	static entityName = 'finishgoodqcconfirmation';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.requestNumber = '';
			this.id = '';
			this.processById = '';
			this.processBy = {};
			this.qcDate = '';
			this.finishGoodQcConfirmationDetail = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}